import { createAction, props } from "@ngrx/store";
import { BannerState } from "../states/bannerState";

export const addToBanner = createAction('[Banner] Add', props<BannerState>())